import { render, staticRenderFns } from "./ApprovalAttachments.vue?vue&type=template&id=6ecb2a46"
import script from "./ApprovalAttachments.vue?vue&type=script&lang=js"
export * from "./ApprovalAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports